<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { isIntradayFeatureEnabled } from '@/utils/featureFlags';

const route = useRoute();

const links = computed(() => {
  const items = [
    { to: '/', label: 'Dashboard' },
    { to: '/crypto', label: 'Crypto 15m' },
    { to: '/daily', label: 'Daily' },
  ];
  if (isIntradayFeatureEnabled()) items.push({ to: '/intraday', label: 'Intraday' });
  items.push(
    { to: '/history', label: 'History' },
    { to: '/simulator', label: 'Paper Simulator' },
    // Trading Advisor is intentionally unlisted — open /advisor directly if you have the URL.
    { to: '/wellbeing', label: 'Wellbeing' },
    { to: '/settings', label: 'Settings' },
  );
  return items;
});

function isActive(path) {
  if (path === '/') return route.path === '/';
  return route.path.startsWith(path);
}
</script>

<template>
  <header class="border-b border-slate-800 bg-slate-900/90 backdrop-blur">
    <div class="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-4">
      <div>
        <p class="text-xs uppercase tracking-widest text-emerald-500">Price Forecast Hub</p>
      </div>
      <nav class="flex flex-wrap gap-1">
        <router-link
          v-for="link in links"
          :key="link.to"
          :to="link.to"
          class="nav-link"
          :class="{ 'nav-link-active': isActive(link.to) }"
        >
          {{ link.label }}
        </router-link>
      </nav>
    </div>
  </header>
</template>
